import i18n from 'i18next';
import { createValidator, validateFields } from 'utils/validators/validators';
import { isValidIban } from 'utils/validators/iban';
import { type FormErrors } from 'hooks/useForm';

// const MIN_BANK_SWIFT_LENGTH = 8;
// const MAX_BANK_SWIFT_LENGTH = 11;
// const BANK_SWIFT_REGULAR_EXPRESSION = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

const validateIban = createValidator<string>(
  (value) => (isValidIban(value) ? null : i18n.t('validations.ibanValidation'))
);

// const validateSwift = createValidator(
//   minLength(MIN_BANK_SWIFT_LENGTH),
//   maxLength(MAX_BANK_SWIFT_LENGTH),
//   matchesRegex(BANK_SWIFT_REGULAR_EXPRESSION, 'swiftValidation')
// );

const fieldValidators = {
  iban: validateIban
  // swift: validateSwift
};

const validateBankDetailFields = (values: any): FormErrors => validateFields(values, fieldValidators);

export {
  validateBankDetailFields
};
